module.exports = __webpack_public_path__ + "img/product2.a29439c7.png";